import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconChevronRight } from '@sorare/core/src/atoms/icons/system/iconChevronRight.ts';

import { kycCtaPill } from '../ui.tsx';

const Root = styled(ButtonBase)`
  --kyc-cta-color: var(--c-yellow-400);
  ${kycCtaPill}
`;

type Props = {
  onClick: () => void;
};
export const ActionRequiredCta = ({ onClick }: Props) => {
  return (
    <Root onClick={onClick}>
      <FormattedMessage defaultMessage="Action required" />
      <FontAwesomeIcon icon={iconChevronRight} />
    </Root>
  );
};
